import React from 'react';
import localization from '../helpers/localization.js';
import {contentRoot} from '../config.js';
let getVisibility= (visible)=>
{
    if(visible)
    {
    return { maxHeight:"500px"};
    }
    else 
    {
    return { maxHeight:"0px"};
    }
}


const InstructionBox = ({visible}) => ( 
 <div className="instructionBox" style={getVisibility(visible)}>
  <img src={contentRoot+"img/logo.png"} alt="logo"></img> 
    <p>{localization.designDreamSauna}</p>
 </div>
);
export default InstructionBox

